export const planWarnings = {
    // Description from core: The dates {{dates}} have already been invoiced.
    // Schedule a new plan starting {{otherDate}} to make changes.
    PLAN_WITH_LOCKED_DATES: 1494934299,
    // Description from core: This plan does not currently reflect recent pricing or availability changes made to {changes}.
    // If you want this plan to follow those changes, check to make sure the plan looks correct, then save it again.
    PLAN_WITH_EARLIER_PRICE_CHANGE: 1541767503,
    // Description from core: This plan does not currently reflect recent pricing or availability changes.
    PLAN_WITH_LATER_PRICE_CHANGE: 1542017193,
    // A plan that should have a sibling discount
    PLAN_WITH_MISSING_SIBLING_DISCOUNT: 1589198424,
    // A plan that is ineligible for a sibling discount
    PLAN_WITH_INCORRECT_SIBLING_DISCOUNT: 1589794980,
};

export const whitelistedWarnings = [
    planWarnings.PLAN_WITH_EARLIER_PRICE_CHANGE,
    planWarnings.PLAN_WITH_LATER_PRICE_CHANGE,
];

export type FREQUENCY = 'YEARLY' | 'MONTHLY' | 'WEEKLY' | 'DAILY';

export type DISCOUNT_ORIGIN = 'custom' | 'preset';

export type PUBLIC_FUNDING_TYPE = 'NONE' | 'UNKNOWN' | 'MANUAL' | 'MANUAL_BY_RATE' | 'ASSISTED';
